import { dateTermVoService } from '../../domain/value-object/DateTermVO'
import DateTimeTermVO from '../../domain/value-object/DateTimeTermVO'
import {
  TextMatchCondition,
  TextMatchMode,
  WbsItemSearchConditionV2VO,
} from '../../domain/value-object/WbsItemSearchConditionV2Vo'
import objects from '../../utils/objects'
import DateTimeVO from '../../domain/value-object/DateTimeVO'
import { ApiResponseValue } from '../model/api'
import { adaptSearchConditionBefore20230125 } from '../compatible-adaptors/wbsItemSearchConditionCompatibleAdaptor'

const migrateTextMatchCondition = (
  value: unknown
): TextMatchCondition[] | undefined => {
  if (!value) return undefined
  if (Array.isArray(value)) {
    if (value.length === 0) return undefined
    if (typeof value[0] === 'string') {
      return value.map(v => ({ value: v, mode: 'include' as TextMatchMode }))
    }
    return value as TextMatchCondition[]
  }
  if (typeof value === 'string') {
    return value ? [{ value, mode: 'include' }] : undefined
  }
  return undefined
}

type WbsItemSearchConditionV2Factory = {
  fromApiResponseToVo: (src: ApiResponseValue) => WbsItemSearchConditionV2VO
}

export const useWbsItemSearchConditionV2Factory =
  (): WbsItemSearchConditionV2Factory => {
    const fromApiResponseToVo = (
      src: ApiResponseValue
    ): WbsItemSearchConditionV2VO => {
      if (!src) return {}
      const adapted = adaptSearchConditionBefore20230125(src)
      const dest: WbsItemSearchConditionV2VO = {}
      for (let entry of Object.entries(adapted)) {
        const key = entry[0]
        const value = entry[1]
        if (!value) continue
        if (key === 'searchText') continue
        if (['code', 'displayName', 'tagUuids'].includes(key)) {
          const migrated = migrateTextMatchCondition(value)
          if (migrated) objects.setValue(dest, key, migrated)
          continue
        }
        if (
          [
            'scheduledStartDate',
            'scheduledEndDate',
            'actualStartDate',
            'actualEndDate',
          ].includes(key)
        ) {
          if (typeof value !== 'object') continue
          const v = dateTermVoService.construct(value['from'], value['to'])
          objects.setValue(dest, key, v)
          continue
        }
        if (['createdAt', 'updatedAt'].includes(key)) {
          const v = new DateTimeTermVO(
            !!value['from'] ? new DateTimeVO(value['from']) : undefined,
            !!value['to'] ? new DateTimeVO(value['to']) : undefined
          )
          objects.setValue(dest, key, v)
          continue
        }
        objects.setValue(dest, key, value)
      }
      return dest
    }
    return {
      fromApiResponseToVo,
    }
  }
